import { render, staticRenderFns } from "./BestAthletesLogo.vue?vue&type=template&id=27fd6d34&"
import script from "./BestAthletesLogo.vue?vue&type=script&lang=ts&"
export * from "./BestAthletesLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports